import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { ClassificacaoItem, EmpresaItem, EstabelecimentoItem, PlanoB2bItem, PlanoB2cItem, ProcedimentoItem } from './catalogo.model';

@Injectable({ providedIn: 'root' })
export class CatalogoService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Catalogo`;

  listarClassificacoes(): Observable<ApiResponse<ClassificacaoItem[]>> {
    return this.http.get<ApiResponse<ClassificacaoItem[]>>(`${this.url}/classificacao`);
  }

  buscarProcedimentos(search?: string, classif?: number, take = 50): Observable<ApiResponse<ProcedimentoItem[]>> {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    if (classif != null) params = params.set('classif', classif.toString());
    params = params.set('take', take.toString());
    return this.http.get<ApiResponse<ProcedimentoItem[]>>(`${this.url}/procedimento`, { params });
  }

  listarPlanosB2c(): Observable<ApiResponse<PlanoB2cItem[]>> {
    return this.http.get<ApiResponse<PlanoB2cItem[]>>(`${this.url}/plano-b2c`);
  }

  listarPlanosB2b(): Observable<ApiResponse<PlanoB2bItem[]>> {
    return this.http.get<ApiResponse<PlanoB2bItem[]>>(`${this.url}/plano-b2b`);
  }

  listarEmpresas(): Observable<ApiResponse<EmpresaItem[]>> {
    return this.http.get<ApiResponse<EmpresaItem[]>>(`${this.url}/empresa`);
  }

  listarEstabelecimentos(): Observable<ApiResponse<EstabelecimentoItem[]>> {
    return this.http.get<ApiResponse<EstabelecimentoItem[]>>(`${this.url}/estabelecimento`);
  }
}
